import React from "react";
import { useFcDimsAndWeightCancel } from "crossdock/modes/inspection/fc-dims-and-weight/buttons/cancel/useFcDimsAndWeightCancel";
import { CancelButton } from "@deliverr/ui-facility/lib-facility/components";

export const FcDimsAndWeightCancelButton: React.FC = () => {
  const { onClick } = useFcDimsAndWeightCancel();

  return <CancelButton onClick={onClick} secondary block />;
};
